import datepicker from "js-datepicker";

document.addEventListener("DOMContentLoaded", function () {
  const body = document.querySelector("body");
  const resultsPanel = document.querySelector(".results");
  const cartEl = document.getElementById("cart");
  const cartEdit = cartEl.querySelector(".cartinfo");
  const cartCountEl = cartEl.querySelector(".cartcount");
  const overlay = document.getElementById("overlay");
  const overlayCloser = overlay.querySelector(".closeIcon");
  const overlayItem = overlay.querySelector(".itemWrap");
  const overlayAddOns = overlay.querySelector(".addons");
  const overlayAddOnChoice = overlayAddOns.querySelectorAll("li.addon");
  const overlayCart = overlay.querySelector(".cartWrap");
  const overlayBottom = overlay.querySelector(".bottom");
  const announcement = document.getElementById("announcement");
  const announcementCloser = announcement.querySelector(".closeIcon");
  const announceCloseBtn = announcement.querySelector(".closeAnnouncement");

  overlayCloser.addEventListener("click", closeOverlay);
  announcementCloser.addEventListener("click", closeAnnouncement);
  announceCloseBtn.addEventListener("click", closeAnnouncement);

  // default page load - load menu
  getAjax("/ajax/instructions.php", function (data) {
    resultsPanel.innerHTML = data;
    //menuInit();
    fadeInResults();
  });

  // click events - need to handle dynamic elements from ajax load

  cartEdit.addEventListener("click", function (event) {
    openCart();
  });

  document.body.addEventListener("click", function (event) {
    // ajax trigger
    if (event.target.classList.contains("trigger")) {
      let withCart = false;
      if (event.target.classList.contains("showCart")) {
        withCart = true;
      }
      ajaxLoad(event.target, withCart);
    }
    // remove from cart
    if (event.target.classList.contains("removeFromCart")) {
      let id = event.target.getAttribute("data-id");
      let wrap = event.target.closest(".cartWrap");
      removeFromCart(id, wrap);
    }
    // the cart qty updates
    if (event.target.classList.contains("qtyAdd")) {
      let cartQty = event.target.closest(".cartQtySelector");
      let cartID = cartQty.getAttribute("data-id");
      let sizeID = cartQty.getAttribute("data-size_id");
      let wrap = event.target.closest(".cartWrap");
      let cartQtyEl = cartQty.querySelector(".qty");
      let cartQtyCount = parseInt(cartQtyEl.innerHTML);
      let newCartQty = ++cartQtyCount;
      cartQtyEl.innerHTML = newCartQty;
      updateCartQty(cartID, sizeID, newCartQty, wrap);
    }
    if (event.target.classList.contains("qtyMinus")) {
      let cartQty = event.target.closest(".cartQtySelector");
      let cartID = cartQty.getAttribute("data-id");
      let sizeID = cartQty.getAttribute("data-size_id");
      let wrap = event.target.closest(".cartWrap");
      let cartQtyEl = cartQty.querySelector(".qty");
      let cartQtyCount = parseInt(cartQtyEl.innerHTML);
      let newCartQty = --cartQtyCount;
      cartQtyEl.innerHTML = newCartQty;
      updateCartQty(cartID, sizeID, newCartQty, wrap);
      if (body.classList.contains("overlayOn")) {
        // if editing in overlay cart simply reload cart
        openCart();
      } else {
        // reload available times btn based on new qty
        let orderDate = document
          .querySelector("#date_field .pickup_date")
          .getAttribute("data-orderdate");
        getAjax(
          "/ajax/getAvailableTimes.php?orderDate=" + orderDate,
          function (data) {
            document.querySelector(".times").innerHTML = data;
            timesBtnInit();
          }
        );
      }
    }
    // handle cart addon clicks
    if (event.target.classList.contains("addon")) {
      let addOnPrice = parseFloat(
        event.target.getAttribute("data-price")
      ).toFixed(2);
      //let qtySel = parseFloat(qtyEl.innerHTML).toFixed(2);
      //let addPriceAdj = parseFloat(addOnPrice * qtySel).toFixed(2);
      let itemPrice = parseFloat(
        document.querySelector(".item_price").getAttribute("data-price")
      ).toFixed(2);
      let newPrice = 0;
      if (event.target.classList.contains("active")) {
        event.target.classList.remove("active");
        newPrice = (parseFloat(itemPrice) - parseFloat(addOnPrice)).toFixed(2);
      } else {
        event.target.classList.add("active");
        newPrice = (parseFloat(itemPrice) + parseFloat(addOnPrice)).toFixed(2);
      }
      document
        .querySelector(".item_price")
        .setAttribute("data-price", newPrice);
      document.querySelector(".item_price").innerHTML = "$" + newPrice;
    }
  });

  // pickup functions

  function pickupInit() {
    const date_field = document.querySelector("#date_field .pickup_date");

    // change label of menu trigger to "edit order" and add cart flag
    document.querySelector(".steps li[data-content='menu']").innerHTML =
      "1. Edit Order";
    document
      .querySelector(".steps li[data-content='menu']")
      .classList.add("showCart");

    // get available times, default to today date
    //let orderDate = formatDate(new Date());
    let orderDate = date_field.getAttribute("data-orderdate");
    getAjax(
      "/ajax/getAvailableTimes.php?orderDate=" + orderDate,
      function (data) {
        document.querySelector(".times").innerHTML = data;
        timesBtnInit();
      }
    );

    // load in cart
    getAjax("/ajax/cart.php", function (data) {
      document.querySelector(".pickup .cartWrap").innerHTML = data;
    });

    if (typeof date_field != "undefined" && date_field != null) {
      const today = new Date();
      const currentDay = new Date();
      const fiveDays = today.setDate(today.getDate() + 5 /*days*/);
      const hours = currentDay.getHours();
      const day = currentDay.getDay();
      let disabledDate = [];
      if (day == 4 || day == 5 || day == 6) {
        if (hours >= 16) {
          disabledDate.push(new Date());
        }
      }
      if (day == 0) {
        if (hours >= 15) {
          disabledDate.push(new Date());
        }
      }
      disabledDate.push(new Date(2021, 11, 25));
      disabledDate.push(new Date(2021, 10, 25));
      disabledDate.push(new Date(2021, 11, 24));
      disabledDate.push(new Date(2021, 11, 25));
      disabledDate.push(new Date(2022, 0, 1));
      // add dates past 2/13/22 disabled to re-opening
      disabledDate.push(new Date(2022, 1, 14));
      disabledDate.push(new Date(2022, 1, 15));
      disabledDate.push(new Date(2022, 1, 16));
      disabledDate.push(new Date(2022, 1, 17));
      disabledDate.push(new Date(2022, 1, 18));
      disabledDate.push(new Date(2022, 1, 19));
      disabledDate.push(new Date(2022, 1, 20));
      disabledDate.push(new Date(2022, 10, 24));

      disabledDate.push(new Date(2022, 11, 24));
      disabledDate.push(new Date(2022, 11, 25));

      // disable thanksgiving 2023
      disabledDate.push(new Date(2023, 10, 23));

      // disable xmas 2023
      disabledDate.push(new Date(2023, 11, 24));
      disabledDate.push(new Date(2023, 11, 31));

      // july 4 2024
      disabledDate.push(new Date(2024, 6, 4));

      // disable thanksgiving 2024
      disabledDate.push(new Date(2024, 10, 28));

      var pickerOptions = {
        minDate: new Date(),
        maxDate: new Date(fiveDays),
        disabler: (date) =>
          date.getDay() === 2 || date.getDay() === 1 || date.getDay() === 3, // add this back to 3 after Thanksgiving
        formatter: (input, date, instance) => {
          const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          };
          const value = date.toLocaleDateString("en-US", options);
          input.value = value; // => '1/1/2099'
        },
        disabledDates: disabledDate,
        onSelect: (instance, date) => {
          // on date select we need to update hidden form field and re-load available times
          if (date != undefined) {
            const value = formatDate(date);
            document.getElementById("dateSelected").value = value;
            document
              .querySelector("#date_field .pickup_date")
              .setAttribute("data-orderdate", value);
            // also need to update the data-orderdate attr for internal use
            getAjax(
              "/ajax/getAvailableTimes.php?orderDate=" + value,
              function (data) {
                document.querySelector(".times").innerHTML = data;
                timesBtnInit();
              }
            );
          } else {
            // keep the current date
            let currentDateSel = document.querySelector("#dateSelected").value;
            currentDateSelDate = new Date(currentDateSel + " PST");
            let calDate = currentDateSelDate.toLocaleDateString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            });
            document.querySelector("#date_field .pickup_date").value = calDate;
            picker.hide();
          }
        },
      };
      const picker = datepicker(date_field, pickerOptions);
    }

    // take over form submit and send via AJAX
    let orderform = document.querySelector("#orderform");
    orderform.addEventListener("submit", function (event) {
      event.preventDefault();

      let timeSelected = orderform.querySelector("#timeSelected").value;
      let dateSelected = orderform.querySelector("#dateSelected").value;
      let fname = orderform.querySelector("#fname").value;
      let lname = orderform.querySelector("#lname").value;
      let email = orderform.querySelector("#email").value;
      let phone = orderform.querySelector("#phone").value;
      let notes = orderform.querySelector("#notes").value;
      let promo = orderform.querySelector("#promo").value;
      let newsletter;
      var isNewsChecked = orderform.querySelector("#newsletter").checked;
      if (isNewsChecked) {
        newsletter = "yes";
      } else {
        newsletter = "no";
      }
      /*
      let sms;
      var isSMSChecked = orderform.querySelector("#sms").checked;
      if (isSMSChecked) {
        sms = "yes";
      } else {
        sms = "no";
      }
      */

      // make sure they selected a pickup time
      if (timeSelected === "") {
        alert("Please choose a pickup time");
        return;
      }

      turnOffNav();
      fadeOutResults();
      showLoader();

      setTimeout(function () {
        postAjax(
          "/placeOrder.php?dateSelected=" +
            dateSelected +
            "&timeSelected=" +
            timeSelected +
            "&fname=" +
            fname +
            "&lname=" +
            lname +
            "&email=" +
            email +
            "&phone=" +
            phone +
            "&notes=" +
            notes +
            "&promo=" +
            promo +
            "&newsletter=" +
            newsletter,
          function (order_id) {
            getAjax(
              "/ajax/confirmation.php?order_id=" + order_id,
              function (data) {
                resultsPanel.innerHTML = data;
                document
                  .querySelector(".steps ul li[data-content='confirmation']")
                  .classList.add("active");

                // change label of menu trigger to "start order" and remove cart flag
                document.querySelector(
                  ".steps li[data-content='menu']"
                ).innerHTML = "1. Edit Order";
                document
                  .querySelector(".steps li[data-content='menu']")
                  .classList.add("showCart");

                hideLoader();

                fadeInResults();
              }
            );
            // trigger email with AJAX - this was moved into placeOrder.php
            //getAjax("/emailOrder.php?order_id=" + order_id, function (data) {});
            if (newsletter === "yes") {
              // add to mailchimp if opt-in
              getAjax(
                "/subscribe.php?email=" +
                  email +
                  "&fname=" +
                  fname +
                  "&lname=" +
                  lname +
                  "&sms=" +
                  sms +
                  "&phone=" +
                  phone,
                function (data) {}
              );
            }
          }
        );
      }, 500);
    });
  }

  // menu functions

  function menuInit() {
    let itemBtns = document.querySelectorAll(".openOverlay");
    let itemBtnsLength = itemBtns.length;
    for (let i = 0; i < itemBtnsLength; ++i) {
      itemBtns[i].addEventListener("click", function (e) {
        e.preventDefault();
        let itemID = this.getAttribute("data-id");
        let sizeID = this.getAttribute("data-sizeid");
        let itemSizeID = this.getAttribute("data-item-size-id");
        let hasSizes = this.getAttribute("data-sizes");
        let catType = this.getAttribute("data-cat-type");
        openOverlay(itemID, sizeID, itemSizeID, hasSizes, catType);
      });
    }

    let qtyBtns = document.querySelectorAll("input.qtyField");
    let qtyBtnsLength = qtyBtns.length;
    for (let i = 0; i < qtyBtnsLength; ++i) {
      qtyBtns[i].addEventListener("change", qtyUpdate);
    }
  }

  // click event to load steps in order process

  function ajaxLoad(el, withCart) {
    turnOffNav();
    if (!withCart) {
      hideCart();
    } else {
      showCart();
    }

    let content = el.getAttribute("data-content");

    if (content === "pickup") {
      // check here for empty cart, alert and exit if empty cart found
      let currentCartCount = parseInt(cartCountEl.innerHTML);
      if (currentCartCount == 0) {
        alert("Please add at least 1 item to your order.");
        return false;
      }
    }

    document
      .querySelector(".steps ul li[data-content='" + content + "']")
      .classList.add("active");

    fadeOutResults();
    setTimeout(function () {
      getAjax("/ajax/" + content + ".php", function (data) {
        resultsPanel.innerHTML = data;
        if (content === "menu") {
          menuInit();
        }
        if (content === "pickup") {
          pickupInit();
        }
        fadeInResults();
      });
    }, 500);
  }

  // helper functions for common tasks

  function timesBtnInit() {
    let timeBtns = document.querySelectorAll(".times button");
    let timeBtnsLength = timeBtns.length;

    function removeTimeSelect() {
      for (let i = 0; i < timeBtnsLength; ++i) {
        timeBtns[i].classList.remove("selected");
      }
    }

    for (let i = 0; i < timeBtnsLength; ++i) {
      timeBtns[i].addEventListener("click", function (e) {
        e.preventDefault();
        if (this.classList.contains("inactive")) {
          return;
        }
        removeTimeSelect();
        let time = this.getAttribute("data-time");
        this.classList.add("selected");

        document.getElementById("timeSelected").value = time;
      });
    }
  }

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  function showCart() {
    cartEl.classList.add("on");
  }

  function hideCart() {
    cartEl.classList.remove("on");
  }

  function openOverlay(itemID, sizeID, itemSizeID, hasSizes, catType) {
    // resets for lightbox data
    document.getElementById("item_notes").value = "";
    qtyCount = 1;
    qtyEl.innerHTML = "1";

    overlayAddOnChoice.forEach((item) => {
      item.classList.remove("active");
    });

    qtyEl.classList.remove("pizza");
    if (catType === "pizza") {
      qtyEl.classList.add("pizza");
    }
    overlayItem.style.display = "flex";
    overlayBottom.style.display = "flex";
    overlayCart.style.display = "none";
    overlayAddOns.style.display = "none";
    // ajax call to database to update the overlay element with correct item details
    getAjax(
      "/ajax/getItem.php?id=" +
        itemID +
        "&sizeID=" +
        sizeID +
        "&hasSizes=" +
        hasSizes,
      function (data) {
        let results = JSON.parse(data);
        overlay.querySelector(".addtocart").setAttribute("data-id", itemSizeID);
        overlay.querySelector(".item_name").innerHTML =
          results.name + " " + results.size;
        overlay.querySelector(".item_description").innerHTML =
          results.description;
        overlay
          .querySelector(".item_price")
          .setAttribute("data-price", results.price);
        overlay.querySelector(".item_price").innerHTML = "$" + results.price;
        if (hasSizes === "yes") {
          overlayAddOns.style.display = "flex";
        }
        body.classList.add("overlayOn");
      }
    );
  }

  function openCart() {
    overlayItem.style.display = "none";
    overlayBottom.style.display = "none";
    overlayCart.style.display = "flex";
    getAjax("/ajax/cart.php", function (data) {
      overlayCart.innerHTML = data;
    });
    body.classList.add("overlayOn");
  }

  // handle qty indicator
  let qtySelector = overlay.querySelector(".qtySelector");
  let qtyEl = qtySelector.querySelector(".qty");
  let qtyCount = parseInt(qtyEl.innerHTML);
  let qtyAdd = qtySelector.querySelector(".plus");
  let qtyMinus = qtySelector.querySelector(".minus");
  qtyAdd.addEventListener("click", function (e) {
    e.preventDefault();
    qtyCount++;
    qtyEl.innerHTML = qtyCount;
  });
  qtyMinus.addEventListener("click", function (e) {
    e.preventDefault();
    qtyCount--;
    if (qtyCount < 0) {
      qtyCount = 0;
    }
    qtyEl.innerHTML = qtyCount;
  });

  // handle add to cart btn
  let addToCartBtn = overlay.querySelector(".addtocart");
  addToCartBtn.addEventListener("click", function (e) {
    e.preventDefault();
    let id = this.getAttribute("data-id");
    let qty = parseInt(qtyEl.innerHTML);
    let notes = document.getElementById("item_notes").value;
    let pizzaQty = 0;
    if (qtyEl.classList.contains("pizza")) {
      pizzaQty = qty;
    }
    // need to loop through add-ons, any "active" classes need to be added to cart
    let addOnStr = "";
    overlayAddOnChoice.forEach((item) => {
      if (item.classList.contains("active")) {
        let addID = item.getAttribute("data-id");
        addOnStr += addID + ",";
      }
    });
    addToCart(id, qty, pizzaQty, notes, addOnStr);
    closeOverlay();
    showCart();
  });

  function updateCartQty(id, size_id, qty, el) {
    let orderDate = document
      .querySelector("#date_field .pickup_date")
      .getAttribute("data-orderdate");
    getAjax(
      "/ajax/updateCartQty.php?id=" +
        id +
        "&size_id=" +
        size_id +
        "&qty=" +
        qty,
      function (data) {
        let results = JSON.parse(data);

        // if cart is empty bring back to menu
        if (results.cartQty == 0) {
          // remove item from cart
          removeFromCart(id, el);

          // update cart count to 0
          cartCountEl.innerHTML = 0;

          // redirect to menu
          let menuEl = document.querySelector(
            ".steps li.trigger[data-content='menu']"
          );
          ajaxLoad(menuEl, true);
          return false;
        }

        if (results.pizzaQty <= 6) {
          // reload cart
          getAjax("/ajax/cart.php", function (response) {
            el.innerHTML = response;
          });
          cartCountEl.innerHTML = results.cartQty;

          getAjax(
            "/ajax/getAvailableTimes.php?orderDate=" + orderDate,
            function (data) {
              document.querySelector(".times").innerHTML = data;
              timesBtnInit();
            }
          );

          // reload cart only if cart is open
          if (body.classList.contains("overlayOn")) {
            openCart();
          }
        } else {
          alert(
            "Online orders are limited to 6 pizzas.  To continue please include 6 or less pizzas.  For larger orders please call us at 323-346-6811."
          );
          // reload cart and available times to reset state
          getAjax(
            "/ajax/getAvailableTimes.php?orderDate=" + orderDate,
            function (data) {
              document.querySelector(".times").innerHTML = data;
              timesBtnInit();
            }
          );
          getAjax("/ajax/cart.php", function (response) {
            el.innerHTML = response;
          });
          // reload cart only if cart is open
          if (body.classList.contains("overlayOn")) {
            openCart();
          }
        }
      }
    );
  }

  function removeFromCart(id, el) {
    getAjax("/ajax/removeFromCart.php?id=" + id, function (data) {
      // reload cart
      getAjax("/ajax/cart.php", function (response) {
        el.innerHTML = response;
      });
      // update cart count
      cartCountEl.innerHTML = data;
      // if cart is empty bring back to menu
      if (data == 0) {
        let menuEl = document.querySelector(
          ".steps li.trigger[data-content='menu']"
        );
        ajaxLoad(menuEl, true);
      }
    });
  }

  function addToCart(id, qty, pizzaQty, notes, addOnStr) {
    getAjax(
      "/ajax/addToCart.php?id=" +
        id +
        "&qty=" +
        qty +
        "&pizzaQty=" +
        pizzaQty +
        "&notes=" +
        notes +
        "&addOnStr=" +
        addOnStr,
      function (data) {
        let results = JSON.parse(data);
        if (results.cartFull === "yes") {
          alert(
            "Online orders are limited to 6 pizzas.  To continue please include 6 or less pizzas.  For larger orders please call us at 323-346-6811."
          );
        } else {
          // return value is updated qty count
          cartCountEl.innerHTML = results.cartQty;
        }
      }
    );
  }
  function turnOffNav() {
    let triggers = document.querySelectorAll(".steps ul .trigger");
    let triggerLength = triggers.length;
    for (let i = 0; i < triggerLength; ++i) {
      triggers[i].classList.remove("active");
    }
  }
  function closeOverlay() {
    body.classList.remove("overlayOn");
  }
  function closeAnnouncement() {
    body.classList.remove("announcementOn");
  }
  function fadeOutResults() {
    resultsPanel.classList.add("hide");
  }
  function fadeInResults() {
    resultsPanel.classList.remove("hide");
  }
  function showLoader() {
    body.classList.add("loaderOn");
  }
  function hideLoader() {
    body.classList.remove("loaderOn");
  }
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    window.scroll(0, 0);
    return xhr;
  }
  function postAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("POST", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    window.scroll(0, 0);
    return xhr;
  }
});
